module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/thumbnail_Haruki Nakajima-13325969974c5a756efd8c9d8e690523.png";